import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Seo, { SEOContext } from 'gatsby-plugin-wpgraphql-seo';
import { Header } from './header';
import { Footer } from './footer';
import classNames from 'classnames';
import { isBrowser } from '../../model/util';

import '../../styles/main.scss';

const Layout = ({
  isHomePage,
  children,
  location,
  seoData,
  issueName,
  onPlayVideo,
  postData,
  wpPage,
}) => {
  const {
    wp: {
      generalSettings: { title },
      seo,
    },
  } = useStaticQuery(graphql`
    query LayoutQuery {
      wp {
        generalSettings {
          title
        }
        seo {
          contentTypes {
            post {
              title
              schemaType
              metaRobotsNoindex
              metaDesc
            }
            page {
              metaDesc
              metaRobotsNoindex
              schemaType
              title
            }
          }
          webmaster {
            googleVerify
            yandexVerify
            msVerify
            baiduVerify
          }
          schema {
            companyName
            personName
            companyOrPerson
            wordpressSiteName
            siteUrl
            siteName
            inLanguage
            logo {
              sourceUrl
              mediaItemUrl
              altText
            }
          }
          social {
            facebook {
              url
              defaultImage {
                sourceUrl
                mediaItemUrl
              }
            }
            instagram {
              url
            }
            linkedIn {
              url
            }
            mySpace {
              url
            }
            pinterest {
              url
              metaTag
            }
            twitter {
              username
              cardType
            }
            wikipedia {
              url
            }
            youTube {
              url
            }
          }
        }
      }
    }
  `);

  /**
   * Add/Remove classes to HTML tag depending on location
   *
   * add browser checks before we use 'document'
   */
  const pageLocation = ['home', 'documentaries-listing'];

  let htmlTagElement;
  if (isBrowser) {
    htmlTagElement = document.getElementsByTagName('html')[0];
  }

  if (htmlTagElement) {
    if (pageLocation.includes(location)) {
      htmlTagElement.classList.add('smooth-scroll');
    } else {
      htmlTagElement.classList.remove('smooth-scroll');
    }
  }

  /**
   * Set post SEO data
   */
  let postSeo;
  if (seoData) {
    postSeo = {
      seo: {
        ...seoData,
      },
    };
  }

  const pageLayout = (
    <div className={classNames(['global-wrapper', location])} data-is-root-path={isHomePage}>
      <Header
        location={location}
        issueName={issueName}
        onPlayVideo={onPlayVideo}
        postData={postData}
        wpPage={wpPage}
      />
      <main className="site-main">{children}</main>
      <Footer siteTitle={title} showIssueLinks={location === 'home'} />
    </div>
  );

  if (seo) {
    return (
      <SEOContext.Provider value={{ global: seo }}>
        {postSeo && <Seo post={postSeo} />}
        {pageLayout}
      </SEOContext.Provider>
    );
  } else {
    return <>{pageLayout}</>;
  }
};

export default Layout;
